<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/account' }">账户</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="editDetails(3)">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails(1)">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="code：">
                                    {{ list.code }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="名称：">
                                    {{ list.name }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="上级名称：">
                                    <div class="read_only read_only_link">
                                        <span @click="dataChange(list.parent_rid)">{{ list.parent_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="身份类型："> {{ list.identity_type_label }} </el-form-item></el-col
                            >
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="合作方名称：">
                                    {{ list.partner_name }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="省份：">
                                    {{ list.province_name }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="寰通编号：">
                                    {{ list.huantong_code }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="城市：">
                                    {{ list.city_name }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="寰通名称：">
                                    {{ list.huantong_name }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="区县：">
                                    {{ list.county_name }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="纬度：">
                                    {{ list.latitude }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="主联系人：">
                                    <div class="read_only read_only_link">
                                        <span @click="mainClick(list.main_contact_rid)">{{ list.main_contact_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="经度：">
                                    {{ list.longitude }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="地址：">
                                    <div class="read_only">
                                        {{ list.address }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="统一社会信用代码：">
                                    {{ list.social_credit_code }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="查询日期：">
                                    {{ list.query_date }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="经营状态：">
                                    {{ list.reg_status }}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="注册资本："> {{ list.reg_capital }} </el-form-item></el-col
                            >
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="法定代表人：">
                                    {{ list.legal_person_name }}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="成立日期：">
                                    {{ list.estiblish_time }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="营业期限自：">
                                    {{ list.from_time }}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="营业期限至："> {{ list.to_time }} </el-form-item></el-col
                            >
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="核准日期：">
                                    {{ list.approved_time }}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="企业类型：">
                                    {{ list.company_org_type }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="员工人数范围：">
                                    {{ list.staff_num_range }}
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="参保人数："> {{ list.social_staff_num }} </el-form-item></el-col
                            >
                        </el-row>

                        <el-row>
                            <el-col :span="12"> <el-form-item label="所有人："> </el-form-item></el-col>

                            <el-col :span="12">
                                <el-form-item label="SF代码：">
                                    {{ list.sf_code }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row style="height: auto">
                            <el-col :span="12">
                                <el-form-item label="经营范围：">
                                    <div class="read_only">
                                        {{ list.business_scope }}
                                    </div>
                                </el-form-item></el-col
                            >
                            <el-col :span="12">
                                <el-form-item label="确信度：">
                                    <div class="read_only">
                                        {{ list.confidence_label }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="类别：">
                                    <div class="read_only">
                                        {{ list.category_code_label }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="类型：">
                                    <div class="read_only">
                                        {{ list.type_name }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="渠道类型参考：">
                                    <div class="read_only">
                                        {{ list.channel_type_reference }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="渠道类型：">
                                    <div class="read_only">
                                        {{ list.channel_type_code_label }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="验证信息：">
                                    {{ list.verification_info }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="备注：">
                                    {{ list.remark }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div></el-form-item
                                ></el-col
                            >
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div></el-form-item
                                ></el-col
                            >
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="联系人关联实体" name="2">
                    <vContactComponent v-if="flag1" :postList="postList1"></vContactComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="子级信息" name="3">
                    <vAccountComponent v-if="flag2" :postList="postList2"></vAccountComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="账户别名" name="4">
                    <vAccountAliasComponent v-if="flag" :postList="postList"></vAccountAliasComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="商业配置" name="5">
                    <vFlowConfig01Component v-if="flag3" :postList="postList3"></vFlowConfig01Component>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vAccountAliasComponent from '../../listComponent/basicdata/account/accountAliasComponent.vue';
import vContactComponent from '../../listComponent/basicdata/contact/contactUpComponent.vue';
import vAccountComponent from '../../listComponent/basicdata/account/accountComponent.vue';
import vFlowConfig01Component from '../../listComponent/basicdata/flowConfig01/flowConfig01Component.vue';

export default {
    name: 'accountDetails',
    components: {
        vAccountAliasComponent,
        vContactComponent,
        vAccountComponent,
        vFlowConfig01Component
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                addBtn: true,
                setBtn: true,
                params: {
                    account_rid: ''
                }
            },
            flag1: false,
            postList1: {
                headerTitle: false,
                addBtn: true,
                setBtn: true,
                params: {
                    account_rid: '',
                    partner_name: ''
                }
            },
            flag2: false,
            postList2: {
                headerTitle: false,
                code: false,
                name: false,
                social_credit_code: false,
                parent_name: false,
                huantong_code: false,
                province_rid: false,
                city_rid: false,
                type: false,
                addBtn: true,
                searchBtn: false,
                resetBtn: false,
                downFileBtn: false,
                setBtn: true,
                params: {
                    parent_rid: '',
                    detail_type: '',
                    detail_type_label: '',
                    partner_name: '',
                    partner_id: ''
                }
            },
            flag3: false,
            postList3: {
                // 如果只要RID，从路由上面拿
                headerTitle: false,
                params: {
                    business_rid: this.$route.query.id
                }
            },
            headerTitle: '账户详情',
            account_alias: {}, //账户别名
            activeNames: ['1', '2', '3', '4', '5'],
            rid: this.$route.query.id,
            list: {}
        };
    },
    mounted() {
        this.flag = false;
        this.flag1 = false;
        this.flag2 = false;
        this.flag3 = false;
        this.getDetails(); //获取详情
        this.$nextTick(() => {
            this.flag = true;
            this.flag1 = true;
            this.flag2 = true;
            this.flag3 = true;
        });
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.getDetails(); //获取详情
        }
    },
    methods: {
        //删除
        amend(id) {
            var params = {
                id: id
            };
            let messages = '删除账户会同时删除账户别名，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .accountDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/account'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //主联系人查看
        mainClick(rid) {
            this.$router.push({
                path: 'contactDetail',
                query: {
                    id: rid
                }
            });
        },
        //点击链接刷新页面
        dataChange(id) {
            this.$router.push({
                path: 'accountDetails',
                query: {
                    id: id
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/account' });
            } else {
                this.$router.go(-1);
            }
        },
        //前往 新增编辑页面
        editDetails(type) {
            this.$router.push({
                path: 'accountEdit',
                query: {
                    type: type,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'accountEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .accountDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                        this.entity_type = 'account';
                        this.entity_rid = res.data.rid;
                        this.postList.params.account_rid = res.data.rid;
                        this.postList1.params.account_rid = res.data.rid;
                        this.postList1.params.partner_name = res.data.name;
                        this.postList2.params.parent_rid = res.data.rid;
                        this.postList2.params.detail_type = res.data.type;
                        this.postList2.params.detail_type_label = res.data.type_label;
                        this.postList2.params.partner_name = res.data.name;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>